import React from 'react'
// import foliohome02 from '../assets/foliohome02.png'

const Home = () => {


  return (
    <div className="home-container">
      <img className="home-image" src="https://res.cloudinary.com/project-3/image/upload/v1698769873/portfolio23/foliohome02_ggv4hy.png" alt="home image"></img>
      <div className="home-info">
        <p>Anna Monkman.</p>
        <p>London based artist</p>
      </div>
    </div>
  )
}

export default Home
